const createCampaignSlice = (set, get) => ({
  campaignErrors: {},
  setCampaignError: (field, error) => set((state) => ({ campaignErrors: { ...state.campaignErrors, [field]: error } })),
  clearCampaignError: (field) => set((state) => {
    const newErrors = { ...state.campaignErrors };
    delete newErrors[field];
    return { campaignErrors: newErrors };
  }),
  clearAllCampaignErrors: () => set({ campaignErrors: {} })
});

export default createCampaignSlice;
